import { PaginationV2 } from "@/domain/entities/Pagination";

export type DutyTaxConfigurationStatus = "active" | "inactive";

export const DUTY_TAX_CONFIGURATION_SORTABLE_COLUMNS = [
  "destination_country_code",
  "commodity_code",
  "min_weight_kg",
  "max_weight_kg",
  "deminimis_value",
  "status",
  "created_at",
  "updated_at"
] as const;

export type DutyTaxConfigurationSortBy = typeof DUTY_TAX_CONFIGURATION_SORTABLE_COLUMNS[number];

export const DUTY_TAX_CONFIGURATION_DEFAULT_SORT_BY: DutyTaxConfigurationSortBy =
  "destination_country_code";

export interface DutyTaxConfigurationListFilter {
  page?: number;
  limit?: number;
  destinationCountryCode?: string;
  status?: DutyTaxConfigurationStatus | "";
  search?: string;
  sortBy?: DutyTaxConfigurationSortBy | "";
  sortDir?: "asc" | "desc" | "";
}

export interface DutyTaxConfigurationListItem {
  no: number;
  destinationCountryCode: string;
  destinationCountryName: string;
  commodityCode: string;
  commodityName: string;
  minWeightKg: number;
  maxWeightKg: number;
  deminimisValue: number;
  destinationCurrencyCode: string;
  documentCircularRequired: boolean;
  selfClearanceRequired: boolean;
  status: DutyTaxConfigurationStatus;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
}

export interface DutyTaxConfigurationListResult {
  data: DutyTaxConfigurationListItem[];
  pagination: PaginationV2;
}

// --- Resolve/check (GENESIS-20471) — frozen contract per BE GENESIS-20446 ---

export interface DutyTaxResolveItemInput {
  commodityCode: string;
  summedPrice: number;
  firstInputIndex: number;
}

export interface DutyTaxResolveParams {
  destinationCountryCode: string;
  chargeableWeightKg: number;
  originCurrency: string;
  items: DutyTaxResolveItemInput[];
}

export interface DutyTaxResolveWeightRange {
  minWeightKg: number;
  maxWeightKg: number;
}

export interface DutyTaxResolveResult {
  deminimisValue: number;
  destinationCurrencyCode: string;
  deminimisExceeded: boolean;
  documentCircularRequired: boolean;
  selfClearanceRequired: boolean;
  matchedCommodityCode: string;
  matchedWeightRange: DutyTaxResolveWeightRange | null;
}
